<template>
  <div class="person-page">
    <div class="person-header primary white--text">
      <div class="person-name-container">
        <div class="edit-name-header">
          <v-dialog
            v-model="dialog"
            max-width="500"
          >
            <v-card>
              <v-card-title class="headline">Continue with unsaved changes?</v-card-title>

              <v-card-text>
                Are you sure you want to continue? Unsaved changes will be lost.
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  text
                  @click="continueWithUnsavedChanges()"
                >
                  Continue Anyways
                </v-btn>

                <v-btn
                  color="red darken-1"
                  text
                  @click="dialog = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn
            v-if="(userIsSelected || userIsAdmin) && !editingName"
            color="white"
            icon
            @click="changeEditing(startEditingName)"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            v-if="editingName"
            color="white"
            @click="saveNameEdits()" 
            outlined
          >
            Save
          </v-btn>
          <v-btn
            v-if="editingName"
            color="white"
            @click="editingName = !editingName"  
            outlined
            :style="{'margin-left': '20px'}"
          >
            Cancel
          </v-btn>
        </div>
        <div>
          <span class="person-name">
            <span v-if="!editingName">{{selectedPerson.fName}}</span>
            <v-text-field class="name-edit-text-field" v-model="nameFields['fName']" hide-details dark dense v-if="editingName"></v-text-field>
            <span >{{" "}}</span>
            <span v-if="!editingName">{{selectedPerson.lName}}</span>
            <v-text-field class="name-edit-text-field" v-model="nameFields['lName']" hide-details dark dense v-if="editingName"></v-text-field>
            <span v-if="selectedPerson.nName">{{" ("}}</span>
            <span v-if="!editingName">{{selectedPerson.nName}}</span>
            <v-text-field class="name-edit-text-field" v-model="nameFields['nName']" hide-details dark dense v-if="editingName"></v-text-field>
            <span v-if="selectedPerson.nName">{{")"}}</span>
          </span>
          <br/>
          <span v-if="!editingName">{{selectedPerson.group}}</span>
          <v-text-field class="name-edit-text-field" v-model="nameFields['group']" hide-details dark dense v-if="editingName"></v-text-field>
        </div>
      </div>
    </div>
    <img
    src="https://cdn.vuetifyjs.com/images/cards/road.jpg"
    class="profile-picture"
    >
    <v-container fluid grid-list-lg class="user-info">
      <v-layout row wrap>
        <v-flex xs4>
          <v-card>
            <v-tabs
              v-model="currentItem"
              color="primary"
              grow
              slider-color="primary"
              class="tab-header"
            >
              <v-tab
                v-for="item in leftItems"
                :key="item"
                :href="'#tab-' + item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="currentItem">
              <v-tab-item
                v-for="item in leftItems"
                :key="item"
                :value="'tab-' + item"
                class="tab-page"
              >
                <div class="edit-tab">
                  <v-btn
                    v-if="userIsAdmin && !editing[item]"
                    color="primary"
                    icon
                    @click="changeEditing(startEditing, item)"  
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editing[item]"
                    color="primary"
                    @click="saveEdits(item)" 
                    outlined
                  >
                    Save
                  </v-btn>
                  <v-btn
                    v-if="editing[item]"
                    color="primary"
                    @click="editing[item] = !editing[item]"  
                    outlined
                    :style="{'margin-left': '20px'}"
                  >
                    Cancel
                  </v-btn>
                </div>
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="field in scopedItems(leftLayout[item])"
                      :key="field.label"
                    >
                      <div class="field-label">{{ field.label }}</div>
                      <div
                        class="field-data"
                        v-if="!editing[item]"
                      >{{ selectedPerson[field.id] }}</div>
                      <v-text-field
                        :label="field.label"
                        v-model="editedItems[item][field.id]"
                        v-if="editing[item]"
                      ></v-text-field>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
        <!-- OLD PROJECT CARD -->
        <!-- <v-flex xs4>
          <v-card>
            <v-card-text>
              <div class="card-title flex-title primary--text">
                <span>Projects</span>
                <v-btn
                  v-if="(userIsSelected || userIsAdmin) && !editingSH"
                  color="primary"
                  icon
                  @click="changeEditing(() => {editingSH = true})"  
                >
                  <v-icon>edit</v-icon>
                </v-btn>

                <v-btn
                  v-if="editingSH"
                  color="primary"
                  @click="editingSH = !editingSH" 
                  outlined
                >
                  Save
                </v-btn>
                <v-btn
                  v-if="editingSH"
                  color="primary"
                  @click="editingSH = !editingSH"  
                  outlined
                >
                  Cancel
                </v-btn>
              </div>
              <br/>
              <div class="project-chart">
                <div class="chart">
                  <project-chart :chart-data="chartData"></project-chart>
                </div>
              <div>
                <ul class="unbulleted-list">
                  <li><span class="project-color chart0"></span><span>Project 1</span></li>
                  <li><span class="project-color chart1"></span><span>Project 2</span></li>
                </ul>
              </div>
              </div>
              <br>
              <hr>
              <div class="side-hustle-switch">
                <span class="side-hustle-title">Side Hustle</span>
                <v-switch :disabled="!((userIsSelected || userIsAdmin) && editingSH)">
                  </v-switch></div>
              <v-layout row wrap align-center>
                <v-flex xs12 sm3>
                  <div class="side-hustle-field">Open To:</div>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Number of hours"
                    v-model="SHopenTo"
                    v-if="editingSH"
                  ></v-text-field>
                  <div v-if="!editingSH">
                    {{SHopenTo}}
                  </div>
                </v-flex>
                <v-flex xs12 sm3>
                  <div>Hrs/week</div>
                </v-flex>
                <v-flex xs12 sm3>
                  <div class="side-hustle-field">Preferences:</div>
                </v-flex>
                <v-flex xs12 sm9>
                  <v-textarea
                    label="Preferences"
                    dense
                    v-model="SHpreferences"
                    v-if="editingSH"
                  ></v-textarea>
                  <div v-if="!editingSH">
                    {{SHpreferences}}
                  </div>
                </v-flex>
                <v-flex xs12 sm3>
                  <div class="side-hustle-field">Assigned:</div>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Number of hours"
                    v-model="SHnumHours"
                    v-if="editingSH && userIsAdmin"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <div>Assigned Hours</div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex> -->
        <v-flex xs4>
          <v-card>
            <v-card-text>
              <div class="card-title flex-title primary--text">
                <span>Skills</span>
                <v-btn v-if="userIsSelected || userIsAdmin" to="/skills" outlined class="primary--text">Manage Skills</v-btn>
              </div>
              <br/>
              <div class="card-subtitle primary--text">Level 3: Lead/Teach</div>
              <ul class="unbulleted-list">
                <li
                  class="skill-li"
                  v-for="skill of selectedPersonSkillsRating3"
                  :key="skill.key"
                >
                  <span v-if="skill.Name === 'None'" class="no-skills-label">None</span>
                  <span v-if="skill.Name !== 'None'" class="skill-label">
                    <v-img :src="skill.ImageUrl" class="skill-image" max-width="16pt"></v-img>
                    {{skill.Name}}
                  </span>
                  <v-icon v-if="skill.Core === 'TRUE'" class="core-icon" color=primary>$jglogo</v-icon>
                </li>
              </ul>
              <hr>
              <br>
              <div class="card-subtitle primary--text">Level 2: Confident/Experienced</div>
              <ul class="unbulleted-list">
                <li
                  class="skill-li"
                  v-for="skill of selectedPersonSkillsRating2"
                  :key="skill.key"
                >
                  <span v-if="skill.Name === 'None'" class="no-skills-label">None</span>
                  <span v-if="skill.Name !== 'None'" class="skill-label">
                    <v-img :src="skill.ImageUrl" class="skill-image" max-width="16pt"></v-img>
                    {{skill.Name}}
                  </span>
                  <v-icon v-if="skill.Core === 'TRUE'" class="core-icon" color=primary>$jglogo</v-icon>
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
  
</template>
<script>
import ProjectChart from "./ProjectChart.vue";
import { updatePersonInfo } from "@/vue-service-person.js";

export default {
  components: {
    "project-chart": ProjectChart
  },
  data(){
    return {
      currentItem: "tab-Contact",
      leftItems: ["Contact", "Employment", "Misc."],
      leftLayout: {
        "Personal": [
          {label: "Work Email",       id: "email",          requiresUser: false,  requiresAdmin: false},
          {label: "ONSIP Extension",  id: "onsipExtension", requiresUser: false,  requiresAdmin: false},
          {label: "Personal Email",   id: "email1",         requiresUser: false,  requiresAdmin: false},
          {label: "Mobile Number",    id: "phone1",         requiresUser: false,  requiresAdmin: false},
          {label: "Street",           id: "street",         requiresUser: true,   requiresAdmin: false},
          {label: "City",             id: "city",           requiresUser: true,   requiresAdmin: false},
          {label: "Zip",              id: "zip",            requiresUser: true,   requiresAdmin: false}
        ],
        "Employment": [
          {label: "Start Date",       id: "startDate",  requiresUser: false, requiresAdmin: false},
          {label: "Status",           id: "status",     requiresUser: false, requiresAdmin: false},
          {label: "Active Employee",  id: "active",     requiresUser: false, requiresAdmin: false},
          {label: "Group",            id: "group",      requiresUser: false, requiresAdmin: false},
          {label: "Kelmar ID",        id: "kelmarId",   requiresUser: true,   requiresAdmin: false},
        ],
        "Contact": [
          {label: "Share Birthday",       id: "shareBirthDate",         requiresUser: true, requiresAdmin: false},
          {label: "Birthday",             id: "birthDate",              requiresUser: true, requiresAdmin: false},
          {label: "Emergency Contact",    id: "emergencyName",          requiresUser: true, requiresAdmin: false},
          {label: "Contact Relationship", id: "emergencyRelationship",  requiresUser: true, requiresAdmin: false},
          {label: "Contact Phone",        id: "emergencyPhone1",        requiresUser: true, requiresAdmin: false},
        ],
        "Misc.": [
          {label: "Share Birthday",       id: "shareBirthDate",         requiresUser: true, requiresAdmin: false},
          {label: "Birthday",             id: "birthDate",              requiresUser: true, requiresAdmin: false},
          {label: "Emergency Contact",    id: "emergencyName",          requiresUser: true, requiresAdmin: false},
          {label: "Contact Relationship", id: "emergencyRelationship",  requiresUser: true, requiresAdmin: false},
          {label: "Contact Phone",        id: "emergencyPhone1",        requiresUser: true, requiresAdmin: false},
        ]
      },
      chartData: {
        labels: ["Project1", "Project2"],
        datasets: [
          {
            label: 'Red',
            backgroundColor: ["#1198aa", "#88CCD5"],
            data: [25, 75]
          }
        ],
      },
      editing: {"Contact": false, "Employment": false, "Misc.": false},
      editedItems:{
        "Contact": {
          email: "",
          email1: "",
          onsipExtension: "",
          phone1: "",
          street: "",
          city: "",
          zip: "",
        },
        "Employment": {
          startDate: "",
          status: "",
          active: "",
          group: "",
          kelmarId: "",
        },
        "Misc.": {
          shareBirthDate: "",     
          birthDate: "",          
          emergencyName: "",      
          emergencyRelationship: "",
          emergencyPhone1: "",   
        },
      },
      editingSH: false,
      SHopenTo: "",
      SHnumHours: "",
      SHpreferences: "",
      editingName: false,
      nameFields: {fName: "", lName: "", nName: "", group: ""},
      prevSelectedPerson: null,
      dialog: false,
      pendingEdit: null,
      pendingArgs: [],
    }
  },
  computed: {
    selectedPerson() {
      let person = this.$store.getters.people[this.$store.getters.selectedPersonKey];
      if(this.prevSelectedPerson !== null && this.prevSelectedPerson !== person){
        // Different Person
        for(let key in this.editing){
          this.editing[key] = false;
        }
        this.editingName = false;
        this.editingSH = false;
      }
      this.prevSelectedPerson = person;
      return person;
    },
    selectedPersonSkillsRating2(){
      const technologies = this.$store.getters.technology;
      const skills = this.$store.getters.selectedPersonSkillsRating;
      const rating2Skills = Object.keys(skills).filter(key => skills[key].Rating === 2).map(key => Object.assign({key: key}, technologies[key]));
      if(rating2Skills.length === 0){
        return [{key: 1, Name: "None"}];
      }
      return rating2Skills;
    },
    selectedPersonSkillsRating3(){
      const technologies = this.$store.getters.technology;
      const skills = this.$store.getters.selectedPersonSkillsRating;
      const rating3Skills = Object.keys(skills).filter(key => skills[key].Rating === 3).map(key => Object.assign({key: key}, technologies[key]));
      if(rating3Skills.length === 0){
        return [{key: 1, Name: "None"}];
      }
      return rating3Skills;
    },
    userIsAdmin() {
      return this.$store.getters.administrator;
    },
    userIsSelected(){
      return this.$store.getters.selectedPersonIsUser;
    }
  },
  methods: {
    scopedItems(items){
      return items.filter(item => {
        return (!item.requiresAdmin || this.userIsAdmin) &&
            (!item.requiresUser || ( this.userIsAdmin || this.userIsSelected ));
      })
    },
    startEditing(item){
      for(let field in this.editedItems[item]){
        this.editedItems[item][field] = this.selectedPerson[field]
      }
      this.editing[item] = !this.editing[item];
    },
    saveEdits(item){
      this.editing[item] = false;

      // Merge the current person with their edited data, then save the whole thing to firebase
      let basePerson = Object.assign({}, this.selectedPerson);
      for(let key in this.editedItems[item]){
        let field = this.editedItems[item][key];
        if(field !== undefined){
          basePerson[key] = field;
        }
      }
      updatePersonInfo(this.selectedPerson.email, basePerson)
    },
    startEditingName(){
      for(let field in this.nameFields){
        this.nameFields[field] = this.selectedPerson[field];
      }
      this.editingName = !this.editingName;
    },
    saveNameEdits(){
      this.editingName = false;

      let basePerson = Object.assign({}, this.selectedPerson);
      for(let key in this.nameFields){
        let field = this.nameFields[key];
        if(field !== undefined){
          basePerson[key] = field;
        }
      }
      updatePersonInfo(this.selectedPerson.email, basePerson)
    },
    changeEditing(func, ...args){
      let editing = false;
      for(let key in this.editing){
        editing = editing || this.editing[key];
      }

      // If the user is already editing something, warn them and save the pending edit
      if(editing || this.editingName || this.editingSH){
        this.dialog = true;
        this.pendingEdit = func;
        this.pendingArgs = args;
      } else {
        // If not, go to the new edit
        func(...args);
      }
    },
    continueWithUnsavedChanges(){
      // If the user doesn't care about their unsaved changes, clear their edits and go to the next edit
      this.dialog = false;
      for(let key in this.editing){
        this.editing[key] = false;
      }
      this.editingName = false;
      this.editingSH = false;
      this.pendingEdit(...this.pendingArgs);
    },
  }
}
</script>
<style scoped>
.person-page{
  flex-grow: 1;
  margin-left: -10px;
  margin-right: 10px;
}
.person-header{
  height: 18vh;
  width: 100%;
}
.person-name-container{
  height: 100%;
  display: flex;
  position: relative;
  left: calc(100px + 22vh);
  padding-left: 20px;
  position: relative;
}
.person-name-container div{
  align-self: flex-end;
  padding-bottom: 20px;
}
.person-name{
  font-size: 16pt;
  font-weight: bold;
}
.profile-picture{
  width: 22vh;
  height: 22vh;
  border-style: solid;
  border-color: white;
  border-width: 4px;
  border-radius: 50%;
  position: relative;
  top: -16vh;
  left: 100px;
  box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.2);
}
.field-label{
  color:rgba(0, 0, 0, 0.4);
  text-transform: uppercase;
  font-weight: bold;
  padding-bottom: 5px;
}
.field-data{
  padding-left: 20px;
  padding-bottom: 10px;
}
.user-info{
  margin-top: -15vh
}
.tab-header{
  border-style: solid;
  border-width: 0px 0px 1px 0px;
  border-color: rgba(0, 0, 0, 0.2);
}
.card-title{
  text-transform: uppercase;
  font-size: .875rem;
  font-weight: 500;
  letter-spacing: .0892857143em;
  width: calc(100% + 32px);
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.2);
  margin: -16px;
  padding: 13px 32px 13px 32px;
}
.flex-title{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-subtitle{
  font-size: .875rem;
  font-weight: 500;
  padding: 0px 16px;
  letter-spacing: .0892857143em;
}
.project-chart{
  display: flex;
  align-items: center;
}
.chart{
  width: 50%;
}
.project-color{
  display: inline-block;
  height: 8px;
  width: 32px;
  border-radius: 4px;
  margin-right: 20px;
}
.side-hustle-switch{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
}
.side-hustle-title{
  font-size: 12pt;
  font-weight: bold;
}
.side-hustle-field{
  padding: 5px 0px;
}
.unbulleted-list{
  list-style: none;
}
.skill-li{
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
  width: 50%;
  display: flex;
  justify-content: space-between;
}
hr {
  border: none;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
}
.core-icon{
  margin-left: 20px;
}
.edit-tab{
  position: absolute;
  z-index: 2;
  width: 100%;
  display: flex;
  justify-content: right;
  padding: 5px 5px 0px 0px;
}
.tab-page{
  position: relative;
}
.name-edit-text-field{
  display: inline-block;
}
.edit-name-header{
  position: absolute;
  width: 100%;
  padding-right: calc(140px + 22vh);
  display: flex;
  justify-content: right;
}
.no-skills-label{
  font-weight: normal;
}
.skill-image{
  margin-right: 10px;
}
.skill-label{
  display: flex;
  justify-content: left;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/People/PersonPage.vue